import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxIcon } from '@digipay/ngx-icon';
import { DpIconComponent } from '@client-monorepo/common/icon';

@Component({
  selector: 'common-ui-components-checkbox',
  standalone: true,
  imports: [CommonModule, NgxIcon, DpIconComponent],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent {
  checked = model(false);
  // @ts-expect-error ...
  size = input<'16' | '20' | '24'>(24, {transform: (value: number | undefined) => (value ? value.toString() : undefined)});
  disabled = input<boolean>(false);

  wrapperCLasses = computed(() => this.generateWrapperClasses());

  generateWrapperClasses(): string {
    const sizeClassMap = {
      16: ['radius-tiny', 'border-200'],
      20: ['radius-mini', 'border-300'],
      24: ['radius-small', 'border-400'],
    };

    let colorClass;
    if (this.disabled()) {
      // TODO: these background colors need to be changed
      colorClass = this.checked() ? 'border-color-air surface-dim-level-0' : 'border-color-air surface-elevated';
    } else {
      colorClass = this.checked() ? 'border-color-brand surface-brand' : 'border-color-tint surface-elevated';
    }
    return `${colorClass} ${sizeClassMap[this.size()].join(' ')}`;
  }

  itemClick(): void {
    if (!this.disabled()) {
      this.checked.update((ex) => !ex);
    }
  }
}
